const createAction = (type, data = {}) => {
  return { ...data, type }
}

export default createAction
